// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('contacts.timestampingmanagement', {
        url: '/timestamping',
        views: {
            "wideColumnView@contacts": {
                templateUrl: 'main/timestamp/timestampingusers/timestamping/timestamping.tpl.html',
                controller: 'TimeStampingManagementController as vm'
            }
        },
        resolve: {
            locations: locationsResover
        }
    });
}

// @ngInject
function locationsResover(TimeStampingApiService) {
    return TimeStampingApiService.getLocations();
}

// @ngInject
function TimeStampingManagementController($stateParams, $q, $scope, $translate, locations, TimeStampingApiService, TimeStampsAdministrationDialog, loadSpinnerService, AuthService, ToasterService) {
    var vm = this;
    var lastSelectedUser = {};

    var today = new Date();
    var timeStampsGrid = {};
    var timeReportsCopy = {};

    var newTimeReportDatePicker = {};

    var timeReportsGrid = {};
    var startDateInitialized = false;
    var endDateInitialized = false;

    vm.currentPage = 0;
    vm.itemsPerPage = 10;
    vm.searchTerm = "";
    vm.currentPage = 1;

    vm.location = {};
    vm.locations = locations;
    vm.timeStampingUsers = [];
    vm.timeStampingDays = [];
    vm.timeReports = [];

    vm.searchTermChange = searchTermChange;
    vm.loadTimeStampingUsers = loadTimeStampingUsers;
    vm.loadTimeStampingDaysForUser = loadTimeStampingDaysForUser;
    vm.openTimeStampsAdministrationModal = openTimeStampsAdministrationModal;
    vm.openNewTimeStampDayModal = openNewTimeStampDayModal;
    vm.attestAll = attestAll;
    vm.attestTimeStampingDay = attestTimeStampingDay;
    vm.unattestTimeStampingDay = unattestTimeStampingDay;
    vm.getNotificationStyle = getNotificationStyle;
    vm.mayAttestAll = AuthService.canAccess('timeStamping', 'update');

    vm.startDate = new Date(today.getFullYear(), today.getMonth(), 1, 0,0,0,0);
    vm.endDate = today;
    vm.newTimeStampDayDate = today;
    vm.dateDifference = dateDifference;

    vm.showTimeStampsForDay = showTimeStampsForDay;
    vm.timeStampsForDay = [];
    vm.captureTimeStampsGrid = captureTimeStampsGrid;
    vm.getHoursAndMinutes = getHoursAndMinutes;
    vm.handleTimeStampDayCellEditEnded = handleTimeStampDayCellEditEnded;
    vm.handleTimeStampCellEditEnding = handleTimeStampCellEditEnding;
    vm.toggleTimeStampDayNotification = toggleTimeStampDayNotification;
    vm.showTimeReports = false;
    vm.newTimeReportDate = new Date();
    vm.isValidNewTimeReportDate = isValidNewTimeReportDate;
    vm.captureNewTimeReportDatePicker = captureNewTimeReportDatePicker;
    vm.addTimeReport = addTimeReport;
    vm.captureTimeReportsGrid = captureTimeReportsGrid;
    vm.getExcelPrintout = getExcelPrintout;

    activate();

    function activate() {
        if (vm.locations.length > 0) {
            vm.location = vm.locations[0];
        }

        $scope.$watch(function() { return vm.startDate; }, function() {
            if (startDateInitialized) {
                searchTermChange();
            } else {
                startDateInitialized = true;
            }
        });
        $scope.$watch(function() { return vm.endDate; }, function() {
            if (endDateInitialized) {
                searchTermChange();
            } else {
                endDateInitialized = true;
            }
        });
        $scope.$watch(function() { return vm.location.id; },
                      function() { searchTermChange(); });

        $scope.$watch(function() { return vm.newTimeReportDate; },
                      function() {
                          console.log("vm.newTimeReportDate changed");
                      });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        vm.timeReports.length = 0;
        vm.timeStampsForDay.length = 0;
        loadTimeStampingUsers();
        vm.showTimeReports = false;
    }

    function loadTimeStampingUsers() {
        loadSpinnerService.start('mainSpinner');
        TimeStampingApiService.getTimeStampingUsers(vm.startDate, vm.endDate, vm.location.id, vm.currentPage, vm.itemsPerPage, vm.searchTerm).then(function(response) {
            vm.timeStampingUsers = response.data.data;
            vm.totalItems = response.data.totalItems;
        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function loadTimeStampingDaysForUser(user) {
        if (!AuthService.canAccess('timeStamping', 'update')) { return; }
        lastSelectedUser = user;

        TimeStampingApiService.getTimeReports(vm.startDate, vm.endDate, user.id).then(function(response) {
            vm.timeReports = _.sortBy(response.data, function(rep) { return rep.timeStampDay.date; });
            vm.showTimeReports = true;
            console.log("vm.timeReports:");
            console.log(vm.timeReports);
        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function openTimeStampsAdministrationModal(timeStampDay) {
        if (timeStampDay.id !== 0) {
            TimeStampsAdministrationDialog.showDialog(timeStampDay.id, vm.location.id, lastSelectedUser.id).then(function(response) {
                console.log("Modal closed. Response was:");
                console.log(response);
                loadTimeStampingDaysForUser(lastSelectedUser);
            }, function(error) {
                console.log("Modal canceled. Response was:");
                console.log(error);
                loadTimeStampingDaysForUser(lastSelectedUser);
            });
        } else {
            openNewTimeStampDayModal(timeStampDay.date);
        }
    }

    function openNewTimeStampDayModal(date) {
        TimeStampsAdministrationDialog.showDialogNewDate(date, vm.location.id, lastSelectedUser.id).then(function(result) {
            console.log("Modal result was:");
            console.log(result);
            loadTimeStampingDaysForUser(lastSelectedUser);
        }, function(error) {
            console.log(error);
            loadTimeStampingDaysForUser(lastSelectedUser);
        });
    }

    function attestAll() {
        var timeStampingDayIds = [];

        _.forEach(vm.timeReports, function(report) {
            timeStampingDayIds.push(report.timeStampDay.id);
        });

        TimeStampingApiService.attestTimeStampDays(timeStampingDayIds).then(function(response) {
            vm.timeStampingDays.length = 0;
            vm.timeStampingDays = [];
            searchTermChange();
            loadTimeStampingDaysForUser(lastSelectedUser);
        });
    }

    function attestTimeStampingDay(timeStampDay) {
        if (!AuthService.canAccess('timeStamping', 'update')) { return; }
        loadSpinnerService.start('mainSpinner');
        TimeStampingApiService.attestTimeStampDays([timeStampDay.id]).then(function(response) {
            loadTimeStampingDaysForUser(lastSelectedUser);
        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function unattestTimeStampingDay(timeStampDay) {
        if (!AuthService.canAccess('timeStamping', 'update')) { return; }
        loadSpinnerService.start('mainSpinner');
        TimeStampingApiService.unattestTimeStampDays([timeStampDay.id]).then(function(response) {
            loadTimeStampingDaysForUser(lastSelectedUser);
        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function dateDifference(date1, date2) {
        var d1 = new Date("2015-01-01 " + date1);
        var d2 = new Date("2015-01-01 " + date2);
        var diff = d1 - d2;
        var dt = new Date(diff);
        var stringHours = _.padStart(dt.getHours() - 1, 2, '0');
        var stringMinutes = _.padStart(dt.getMinutes(), 2, '0');
        var stringRepresentation = stringHours + ":" + stringMinutes;

        return stringRepresentation;
    }

    function showTimeStampsForDay(timeStampDay) {
        vm.timeStampsForDay.length = 0;
        _.forEach(timeStampDay.userTimeStamps, function(stamp) {
            vm.timeStampsForDay.push(stamp);
        });

        timeStampsGrid.invalidate();
        timeStampsGrid.collectionView.refresh();
    }

    function getHoursAndMinutes(dt) {
        var date = new Date(dt);
        var hours = _.padStart(date.getHours(), 2, '0');
        var minutes = _.padStart(date.getMinutes(), 2, '0');

        return hours + ":" + minutes;
    }

    function handleTimeStampDayCellEditEnded() {
        var reportsToSend = [];
        _.forEach(vm.timeReports, function(report) {
            var matchingCopy = _.find(timeReportsCopy, function(reportCopy) {
                return reportCopy.id === report.id;
            });
            if (report.workTime !== matchingCopy.workTime || report.breakTime !== matchingCopy.breakTime) {
                reportsToSend.push(report);
            }
        });

        if (reportsToSend.length !== 0) {
            loadSpinnerService.start('mainSpinner');
            var promises = [];
            _.forEach(reportsToSend, function(report) {
                var promise = TimeStampingApiService.updateTimeReport(report);
                promises.push(promise);
            });

            $q.all(promises).then(function(responses) {
                _.forEach(responses, function(response) {
                    var matchingReport = _.find(vm.timeReports, function(report) {
                        return report.id === response.data.id;
                    });
                    matchingReport.workTime = response.data.workTime;
                    matchingReport.breakTime = response.data.breakTime;
                });
            }, function(error) {
                ToasterService.showError($translate.instant('error.wrongformat'));
            }).finally(function() {
                loadSpinnerService.stop('mainSpinner');
            });
        }

    }

    function handleTimeStampCellEditEnding() {
        timeReportsCopy = angular.copy(vm.timeReports);
    }

    function toggleTimeStampDayNotification(timeReport) {
        timeReport.timeStampDay.notify = !timeReport.timeStampDay.notify;

        loadSpinnerService.start('mainSpinner');
        TimeStampingApiService.updateTimeReport(timeReport).then(function(response) {
            timeReport.timeStampDay.notify = response.data.timeStampDay.notify;
        }, function(error) {
            ToasterService.showError(error);
            timeReport.timeStampDay.notify = !timeReport.timeStampDay.notify;
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function isValidNewTimeReportDate() {
        var isWithinValidInterval = false;

        var startOfToday = moment().startOf('day');
        // Selected date needs to be between the start date and the end date
        if (vm.newTimeReportDate <= vm.endDate &&
            vm.newTimeReportDate >= vm.startDate &&
            vm.newTimeReportDate < startOfToday
            ) {
            isWithinValidInterval = true;
        }

        var listOfAddedDates = [];
        _.forEach(vm.timeReports, function(report) {
            var dateString = moment(report.timeStampDay.date).format("YYYY-MM-DD");
            listOfAddedDates.push(dateString);
        });

        var selectedDate = moment(vm.newTimeReportDate).format("YYYY-MM-DD");

        if (isWithinValidInterval &&
            !_.find(listOfAddedDates, function(dateString) { return dateString === selectedDate; })) {
            return true;
        }

        return false;
    }

    function addTimeReport() {
        var newTimeReport = {
            timeStampDay: {
                date: moment(vm.newTimeReportDate).format("YYYY-MM-DD"),
                user: {
                    id: lastSelectedUser.id
                }
            }
        };

        loadSpinnerService.start('mainSpinner');
        TimeStampingApiService.createTimeReport(newTimeReport).then(function(response) {
            var allTimeReports = [];
            _.forEach(vm.timeReports, function(rep) { allTimeReports.push(rep); });
            allTimeReports.push(response.data);
            allTimeReports = _.sortBy(allTimeReports, function(rep) {
                return rep.timeStampDay.date;
            });
            vm.timeReports = allTimeReports;
        }, function(error) {
            ToasterService.showError($translate.instant('common.error'));
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function getExcelPrintout() {
        var requestData = {
            startDate: vm.startDate,
            endDate: vm.endDate,
            userIds: [lastSelectedUser.id]
        };

        TimeStampingApiService.downloadExcelFile(requestData);
    }

    function captureTimeReportsGrid(s) {
        timeReportsGrid = s;
    }

    function captureNewTimeReportDatePicker(s) {
        newTimeReportDatePicker = s;
    }

    function captureTimeStampsGrid(s) {
        timeStampsGrid = s;
    }

    function getNotificationStyle(item) {
        var style = {};
        if (item.notify) {
            style['background-color'] = "yellow";
        }
        return style;
    }

}

angular.module('timestamp.timestampingmanagement', [])
    .config(stateConfig)
    .controller('TimeStampingManagementController', TimeStampingManagementController);
